<div class="tooltip-wrapper">
  <mat-icon
    (click)="toggleTooltip()"
    (clickOutside)="this.showTooltip = false"
    [ngClass]="iconClass()"
    [svgIcon]="iconName()"
    class="tooltip-icon"
  ></mat-icon>

  @if (showTooltip) {
  <div class="tooltip">
    <p class="tooltip-content">
      {{ tooltipContent() }}
    </p>
  </div>
  }
</div>
